import React, { useRef } from "react";
import { useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Logo from "../../../assets/img/taskde-Logo.png";
// import AvtarImg from "../../../assets/img/taskde-Logo.png";
import AvtarImg from "../../../assets/img/default-avatar.jpg";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { FaUserCircle } from "react-icons/fa";
import { MdOutlineManageAccounts, MdNotifications } from "react-icons/md";
import { VscSignOut } from "react-icons/vsc";
import { FiStar } from "react-icons/fi";
import { BiRupee, BiUpsideDown, BiUserPin, BiWallet } from "react-icons/bi";
import { IoWallet } from "react-icons/io5";
import notificationimg from "../../../assets/img/notify.jpg";
import { Button, Card, Form, Modal } from "react-bootstrap";
import shape1 from "../../../assets/img/shape1.png";
import shape2 from "../../../assets/img/shape2.png";
import {
  addPaymentRazorpay,
  addPhonepe,
  addUPIID,
  getUpiIdData,
  getWalletDetails,
  withdrawPayment,
  withdrawPaymentRazorpay,
} from "../../../Redux/Wallet/action";
import { useEffect } from "react";
import {
  getNotificationList,
  markAsReadNotification,
} from "../../../Redux/Notification/action";
import moment from "moment";
import {
  getMyTaskList,
  getMyTaskListSeller,
  getTaskCategoryList,
} from "../../../Redux/Task/action";
import { IMAGE_URL } from "../../../api";
import { TbFileDescription } from "react-icons/tb";
import { RiBankLine, RiHandCoinLine } from "react-icons/ri";
import ToasterMessage from "../../ToasterMessage";
import { chatSearchBuyer, userChatStatus } from "../../../Redux/Chats/action";
import { async } from "q";
import { setOneSignal } from "../../functions";
import { deleteAccountUser, userLogout } from "../../../Redux/Auth";
import OneSignalReact from "react-onesignal";
import OneSignal from "react-onesignal";

import SweetAlert from "react-bootstrap-sweetalert";
import loader from "../../../assets/img/loader.gif";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import ZIM from "zego-zim-web";
import { callDuration, preventLoginPushNotification, updateCallDuration } from "../../../Redux/Call/action";
import Timer from "../../ChatCall/Timer";
import CallrateModal from "../../CallrateModal";
import { getUserProfilePhoto } from "../../../Redux/User/action";
import { setSignOutState, setUserLoginDetails } from "../../../slices/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { AiFillDelete, AiFillEdit, AiOutlineDelete } from "react-icons/ai";
import { GrTransaction } from 'react-icons/gr'
import { ToastContainer, toast } from "react-toastify";
import upi_icon from '../../../assets/img/upi_icon.png';

const Header = (props) => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.user);
  const { notificationCount, isAuth } = users
  const location = useLocation();

  const [walletTab, setWalletTab] = useState(
    localStorage.getItem("user_type") && localStorage.getItem("user_type") == 2
      ? "withdraw"
      : "add"
  );
  const [upiId, setupiId] = useState("");
  const [upi, setupi] = useState("");
  const [upiIdSaved, setUpiIdSaved] = useState(false);
  const [editingUpiId, setEditingUpiId] = useState(false);

  // ...

  const handleEditUpiId = () => {
    setEditingUpiId(true);
  };

  const handleSaveUpiId = () => {
    setEditingUpiId(false);
  };

  // ...
  // const [isBackground, setIsBackground] = useState(true);
  const [isswalseller, setIsswalSeller] = useState(false);
  const [isswalbuyer, setIsswalBuyer] = useState(false);
  const [isswaldelete, setIsswalDelete] = useState(false);
  const [toaster, setToaster] = useState("");
  const [count, setCount] = useState("");
  const [menuActive, setMenuActive] = useState(false);
  const [showMediaIcons, setShowMediaIcons] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [update, setUpdate] = useState(false);
  const [showMobileMenuNotify, setShowMobileMenuNotify] = useState(false);
  const [showMobileMenuProfile, setShowMobileMenuProfile] = useState(false);
  const [wallet, setWallet] = useState({});
  const [notifications, setNotifications] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [show, setShow] = useState(false);
  const notification_data = localStorage.getItem("notification_data");
  const [isloader, setIsloader] = useState(false);
  const [toasterone, setToasterOne] = useState("");

  const { updatePage } = props;
  useEffect(() => {
    window.scrollTo(0, 0);
    getNotifications();
    getTaskCategoryList()((response) => {
      if (response && response.status) {
        setTasks(response?.data?.data);
      }
    });
    if (props?.search) {
      setMenuActive(true);
    }
  }, []);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    getWalletDetails()((response) => {
      if (response && response.status) {
        setWallet(response?.data?.data);
        setShow(true);
      }
    });
  };
  const navigate = useNavigate();
  const onClickLogout = async () => {
    let formData = new FormData();
    formData.append("refresh", localStorage.getItem("refresh_token"));
    formData.append(
      "notification_token",
      localStorage.getItem("onesignal_token")
    );
    userChatStatus("2")((response) => {
      if (response.status) {
        userLogout(formData)((response) => {
          if (response.status) {
            // const userID = localStorage.getItem("user_name");
            const userID = localStorage.getItem("user_id");;

            const userName = localStorage.getItem("user_name");
            const appID = 1485872462;
            const serverSecret = "8e9ec2e8a91d24fd83fc68a74bda9f04";
            const TOKEN = ZegoUIKitPrebuilt.generateKitTokenForTest(
              appID,
              serverSecret,
              null,
              userID,
              userName,
            );
            const zp = ZegoUIKitPrebuilt.create(TOKEN);
            zp.destroy();
            localStorage.removeItem("user_type");
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("token");
            localStorage.removeItem("user_name");
            localStorage.removeItem("user_image");
            localStorage.removeItem("user");
            localStorage.removeItem("onesignal_token");
            window.location.href = "/signin";
            // navigate('/signin')
          }
        });
      }
    });
    dispatch(setSignOutState())
    setToaster("Log Out");
    setTimeout(() => {
      setToaster("");
    }, 200000);
  };
  const onClickmarkAsRead = (notification) => {
    let user_type = localStorage.getItem("user_type");
    let pagetype = "buyer";
    if (user_type == 2) {
      pagetype = "seller";
    }

    let id = notification.id;
    markAsReadNotification({ id })((response) => {
      if (response && response.status) {
        getNotifications();
      }
    });
    if (notification?.type == 1) {
      handleShow();
    } else if (notification?.type == 2) {
      if (notification?.task_status?.status == "1") {
        navigate(`/mytasklisting${pagetype}`, {
          state: { data: notification.task_status, is_notification: true },
        });
      } else if (notification?.task_status?.status == "2") {
        user_type == 2
          ? navigate(`/mytasklistingseller`, {
            state: { data: notification, is_notification: true },
          })
          : navigate(`/mytaskassigned${pagetype}`, {
            state: { data: notification.task_status, is_notification: true },
          });
      } else if (notification?.task_status?.status == "3") {
        navigate(`/mytaskcompleted${pagetype}`, {
          state: { data: notification, is_notification: true },
        });
      } else if (notification?.task_status?.status == "4") {
        user_type == 2 ? navigate(`/mytaskseller`) : navigate(`/mytaskbuyer`);
      }
    } else {
    }
  };
  const getNotifications = () => {
    getNotificationList(
      5,
      0
    )((response) => {
      if (response && response.status) {
        setNotifications(response?.data);
        // dispatch(
        //   setUserLoginDetails({
        //     ...users,
        //     notificationCount: response?.count

        //   })
        // )
        setCount(response?.count);
      }
    });
  };

  const [amount, setamount] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    if (amount === "") {
      setToaster("Enter Amount");
      setTimeout(() => {
        setToaster("");
      }, 2000);
    } else {
      setIsloader(true);
      addPhonepe(amount)((response) => {
        if (response && response.status) {
          setIsloader(false);
          window.location.href = response.redirect;
        } else {
          setIsloader(false);
          if (response?.response?.data?.message) {
            toast.error(response.response.data.message, {
              position: toast.POSITION.TOP_RIGHT
            });
          }
        }

      });

    }
  };

  const withdrawAmount = (e) => {
    e.preventDefault();
    if (amount === "") {
      setToaster("Enter Amount");
      setTimeout(() => {
        setToaster("");
      }, 2000);
    } else {
      setIsloader(true);
      withdrawPayment(amount)((response) => {
        if (response && response.status) {
          setIsloader(false);
          getWalletDetails()((response) => {
            if (response && response.status) {
              setWallet(response?.data?.data);
              setShow(false);
              setamount("");
            }
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT
            });
          });
        } else {
          setIsloader(false);
          if (response?.response?.data?.message) {
            toast.error(response.response.data.message, {
              position: toast.POSITION.TOP_RIGHT
            });
          }
        }

      });

    }
  };
  const { id } = useParams();
  const [task, setTask] = useState({});
  const [data, setData] = useState([]);
  // useEffect(() => {

  //     let formData = new FormData();
  //     // formData.append('status_object', 1);
  //     // formData.append('sort_order', 1);
  //     formData.append('sub_category', id);

  //     if (notification_data === "Task Assigned") {
  //         let formData = new FormData();
  //         formData.append('status_object', 2);
  //         // formData.append('sort_order', 1);
  //         // formData.append('category', 1);
  //         getMyTaskListSeller({ formData })((response) => {
  //             if (response && response.status) {
  //                 setTasks(response?.data?.data)
  //             }
  //         });
  //     }
  //     else if (notification_data == "offline message") {
  //         chatSearchBuyer({ formData })((response) => {
  //             if (response && response.status) {
  //                 setData(response?.data?.data)
  //             }
  //         });
  //     }

  //     getNotificationList(5, 0)((response) => {
  //         if (response && response.status) {
  //             setNotifications(response?.data)
  //             setCount(response?.count)
  //         }

  //     });
  //     if (updatePage)
  //         updatePage();
  // }, [update]);

  const onesignal_token = localStorage.getItem("onesignal_token");
  const refresh_token = localStorage.getItem("refresh_token");

  // window.OneSignal = window.OneSignal || [];
  useEffect(() => {
    OneSignalReact.on("notificationDisplay", function (event) {
      let formData = new FormData();
      formData.append("sub_category", id);

      if (notification_data === "Task Assigned") {
        let formData = new FormData();
        formData.append("status_object", 1);

        getMyTaskListSeller({ formData })((response) => {
          if (response && response.status) {
            setTasks(response?.data?.data);
          }
        });
      } else if (notification_data == "offline message") {
        chatSearchBuyer({ formData })((response) => {
          if (response && response.status) {
            setData(response?.data?.data);
          }
        });
      }

      getNotificationList(
        5,
        0,
        1
      )((response) => {
        if (response && response.status) {
          setNotifications(response?.data);
          // dispatch(
          //   setUserLoginDetails({
          //     ...users,
          //     notificationCount: response?.count

          //   })
          // )
          setCount(response?.count);
        }
      });
    });

    // });
  }, []);
  const handleWalletTab = (name) => {
    setWalletTab(name);
  };
  const becomeSeller = () => {
    localStorage.removeItem("user_type");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("token");
    localStorage.removeItem("user_name");
    localStorage.removeItem("user_image");
    localStorage.removeItem("user");
    localStorage.removeItem("onesignal_token");
    window.location.href = "/signin";
  };
  const becomeBuyer = () => {
    localStorage.removeItem("user_type");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("token");
    localStorage.removeItem("user_name");
    localStorage.removeItem("user_image");
    localStorage.removeItem("user");
    localStorage.removeItem("onesignal_token");
    window.location.href = "/signin";
  };

  const onCompleteSweetAlertSeller = () => {
    if (isAuth) {
      setIsswalSeller(true);

    } else {
      navigate("/becomeseller");
    }
  };
  const onCompleteSweetAlertBuyer = () => {
    if (isAuth) {
      setIsswalBuyer(true);
    } else {
      navigate("/becomeseller");
    }
  };

  const onDeleteSweetAlertSeller = () => {
    if (isAuth) {
      setIsswalDelete(true);
    } else {
      navigate("/");
    }
  };

  const deleteAccount = () => {
    deleteAccountUser()((response) => {
      if (response && response.status) {

        localStorage.removeItem("user_type");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("token");
        localStorage.removeItem("user_name");
        localStorage.removeItem("user_image");
        localStorage.removeItem("user");
        localStorage.removeItem("onesignal_token");

        setToaster("Sucessfully Deleted")
        setTimeout(() => {
          setToaster("")

        }, 2000);

        navigate("/signin", { state: { toaster: true } })

      }
      else {
        setToaster("Pending Task")
        setTimeout(() => {
          setToaster("")

        }, 2000);
      }

    });

  }


  const [seconds, setSeconds] = useState(0);
  const [joinRoom, setJoinRoom] = useState(false);
  // Call Function Start
  if (isAuth && localStorage.getItem("user_name")) {
    const roomID = "room01";
    const userID = localStorage.getItem("user_name");
    const userName = userID;
    const appID = 1485872462;
    const serverSecret = "8e9ec2e8a91d24fd83fc68a74bda9f04";
    const TOKEN = ZegoUIKitPrebuilt.generateKitTokenForTest(
      appID,
      serverSecret,
      roomID,
      userID,
      userName
    );
    const zp = ZegoUIKitPrebuilt.create(TOKEN);
    zp.addPlugins({ ZIM });
    zp.setCallInvitationConfig({
      onSetRoomConfigBeforeJoining: () => ({
        turnOnCameraWhenJoining: false,
        showMyCameraToggleButton: false,
        showAudioVideoSettingsButton: false,
        showScreenSharingButton: false,
        showTextChat: false,
        showOnlyAudioUser: true,
        showNonVideoUser: true,
        useFrontFacingCamera: false,
        autoLeaveRoomWhenOnlySelfInRoom: true,

        branding: {
          logoURL:
            "data:image/png;base64,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",
        },
        onUserAvatarSetter: (userList) => {
          userList.forEach((user) => {
            getUserProfilePhoto(user.userID)((response) => {
              const imageUrl = `http://taskde.aventusinformatics.com${response?.data?.data?.image}`;
              user.setUserAvatar(imageUrl);
              return response?.data?.data?.image
            })
          });
        },
        onUserJoin: () => {
          setJoinRoom(true);
        },
        onLeaveRoom: () => {
          setJoinRoom(false);
          setSeconds(0);
        },
      }),
    });
  }
  useEffect(() => {
    if (joinRoom) {
      const intervalId = setInterval(() => {
        setSeconds((seconds) => seconds + 1);
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [joinRoom]);
  // Call Function END Here

  useEffect(() => {
    // ========= PREVENT LOGIN PUSH NOTIFICATION STRAT =========
    if (localStorage.getItem('onesignal_token') && localStorage.getItem('refresh_token') && location.pathname === '/chatsuserlistbuyer' || location.pathname === '/chatsuserlistseller') {
      if (localStorage.getItem('token')) {
        preventLoginPushNotification(true, localStorage.getItem('onesignal_token'))((response) => {
        })
      }

    } else {
      if (localStorage.getItem('token')) {
        preventLoginPushNotification(false, localStorage.getItem('onesignal_token'))((response) => {
        })
      }
    }
    // ========= PREVENT LOGIN PUSH NOTIFICATION END =========

    // ========= SET ONE SIGNAL START =========
    OneSignal.init({
      autoRegister: false,
      appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
      allowLocalhostAsSecureOrigin: process.env.REACT_APP_ONESIGNAL_ALLOW_LOCALHOST,
      // promptOptions: false,
    })
    // ========= SET ONE SIGNAL END =========

  }, [])



  // Function to edit the UPI ID
  const editUPI = () => {
    setEditingUpiId(true);
  };

  // Component initialization
  useEffect(() => {
    if (localStorage.getItem("token")) {
      getUpiIdData()((response) => {
        if (response && response.status) {
          setupiId(response?.data?.data?.upi_id)
          setupi(response?.data?.data?.upi_id)
        }
      });
    }


  }, []);
  // ...
  const saveUPI = () => {
    if (!upi) {
      toast.error("Please enter a valid UPI ID", {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }


    addUPIID(upi)((response) => {

      if (response && response.status) {
        setIsloader(false);
        setupiId(upi)
        setUpiIdSaved(true);
        setEditingUpiId(false);
        toast.success("Success", {
          position: toast.POSITION.TOP_RIGHT
        });
      } else {
        setIsloader(false);
        toast.error(response?.message, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    });
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {joinRoom && (
        <div className="call-timer">
          <Timer time={seconds} />
        </div>
      )}
      <ToasterMessage toaster={toaster} setToaster={setToaster} wallet={wallet} />
      <header id="header" className="header header-scrolled">
        <div className="container-fluid container-xl d-flex align-items-center mainblock">
          <button
            className="d-none"
            id="notification-btn-click"
            onClick={() => setUpdate(!update)}
          ></button>
          <Link to="/" className="logo seperation d-flex align-items-center">
            <img src={Logo} alt="" />
            {/* <span>FlexStart</span> */}
          </Link>
          {/* className={isActive ? 'navbar-mobile' : ''}  onClick={showMenu} */}

          <nav
            id="navbar"
            className={
              showMediaIcons
                ? "navbar navbar-mobile"
                : "navbar navbar-expand-lg"
            }
          >
            <ul>
              {localStorage.getItem("user_type") &&
                localStorage.getItem("user_type") == 2 ? (
                <></>
              ) : (
                <li>
                  {" "}
                  <Link
                    className={
                      isAuth ? "" : "getstarted scrollto"
                    }
                    to={
                      localStorage.getItem("user_type") &&
                        localStorage.getItem("user_type") == 1
                        ? "/services"
                        : "/signin"
                    }
                  >
                    Post a Task
                  </Link>
                </li>
              )}

              {!props?.search && (
                <React.Fragment>
                  {!isAuth && (
                    <React.Fragment>
                      {/* <div className={menuActive ? "search-bar search-bar-show" : "search-bar"}>
                                                <li>
                                                    <Link className='' to='/searchlist'>
                                                        <form className="search-form d-flex align-items-center" >
                                                            <input type="text" name="query" placeholder="Search" title="Search" />
                                                            <button type="submit" title="Search">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className='search-icon' fill="#fff" viewBox="0 0 16 16">
                                                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                                                </svg>
                                                            </button>
                                                        </form>
                                                    </Link>
                                                </li>
                                            </div> */}
                      {/* <div className="d-block d-xl-none d-flex justify-content-end">
                                                <Link className='' to='/'>
                                                    <form className="search-form d-flex align-items-center" >
                                                        <input type="text" name="query" placeholder="Search" title="Search" />
                                                        <button type="submit" title="Search">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className='search-icon' fill="#fff" viewBox="0 0 16 16">
                                                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                                            </svg>
                                                        </button>
                                                    </form>
                                                </Link>
                                            </div> */}
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
              {!isAuth && (
                <li className="dropdown services-tabs">
                  <Link
                    to="/"
                    className={showMobileMenu ? "" : ""}
                    onClick={() => setShowMobileMenu(!showMobileMenu)}
                  >
                    <span>Services</span> <i className="bi bi-chevron-down"></i>
                  </Link>
                  <ul
                    className={showMobileMenu ? "dropdown-active" : "tabs-menu"}
                  >
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey="first"
                    >
                      <Row>
                        <Col sm={12}>
                          <Nav variant="pills" className="flex-column">
                            <div className="tabs-switch">
                              <Nav.Item>
                                <Nav.Link
                                  eventKey="first"
                                  className="buyer-services"
                                >
                                  Buyer
                                  <span>I need to hire someone For ...</span>
                                </Nav.Link>
                                <Nav.Link
                                  eventKey="second"
                                  className="seller-services"
                                >
                                  Seller
                                  <span>I'm looking For work in ...</span>
                                </Nav.Link>
                              </Nav.Item>
                              <div className="col-lg-12">
                                <Tab.Content>
                                  <Tab.Pane eventKey="first">
                                    <div className="row justify-content-center">
                                      {tasks?.map((task, index) => (
                                        <div
                                          className="col-lg-3 col-md-3 col-sm-6 col-12"
                                          key={index}
                                        >
                                          <h5 className="dropdown header_underline">
                                            <span>{task?.name}</span>{" "}
                                          </h5>
                                          <div>
                                            {task?.task.map(
                                              (subTask, subIndex) => (
                                                <div key={subIndex}>
                                                  <Link
                                                    to={"/tasks/" + subTask?.id}
                                                    className="p-0 mt-3"
                                                  >
                                                    {subTask?.name}
                                                  </Link>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                      {/* <div className='col-lg-2 col-md-3 col-sm-6 col-12'>
                                                                            <h5 className="dropdown header_underline"><span>Tax</span> </h5>
                                                                            <div>
                                                                                <div><Link to="/gstatrobuyer" className="p-0 mt-3">GST</Link></div>
                                                                                <div><Link to="/itrastrobuyer" className="p-0 mt-2">ITR</Link></div>
                                                                                <div><Link to="/otherstaxbuyer" className="p-0 mt-2">Others</Link></div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='col-lg-2 col-md-3 col-sm-6 col-12'>
                                                                            <h5 className="dropdown header_underline"><span>Astro</span> </h5>
                                                                            <div>
                                                                                <div><Link to="/careeratrobuyer" className="p-0 mt-3">Career</Link></div>
                                                                                <div><Link to="/relationshipastrobuyer" className="p-0 mt-2">Relationship</Link></div>
                                                                                <div><Link to="/othersastrobuyer" className="p-0 mt-2">Others</Link></div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                                                                            <h5 className="dropdown header_underline"><span>Heal</span> </h5>
                                                                            <div>
                                                                                <div><Link to="/careerhealbuyer" className="p-0 mt-3">Career</Link></div>
                                                                                <div><Link to="/relationshiphealbuyer" className="p-0 mt-2">Relationship</Link></div>
                                                                                <div><Link to="/othershealbuyer" className="p-0 mt-2">Others</Link></div>
                                                                            </div>
                                                                        </div> */}
                                    </div>
                                  </Tab.Pane>
                                  <Tab.Pane eventKey="second">
                                    <div className="row justify-content-center">
                                      <div className="col-lg-3 col-md-3 col-sm-6 col-12">
                                        <h5 className="dropdown header_underline">
                                          <span>Digital</span>{" "}
                                        </h5>
                                        <div>
                                          <div>
                                            <Link
                                              to="/logodesigningpartner"
                                              className="p-0 mt-3"
                                            >
                                              Logo Designing
                                            </Link>
                                          </div>
                                          <div>
                                            <Link
                                              to="/audiovideoeditingpartner"
                                              className="p-0 mt-2"
                                            >
                                              Audio Video Editing
                                            </Link>
                                          </div>
                                          <div>
                                            <Link
                                              to="/digitalmarketingpartner"
                                              className="p-0 mt-2"
                                            >
                                              Digital Marketing
                                            </Link>
                                          </div>
                                          <div>
                                            <Link
                                              to="/othersdigital"
                                              className="p-0 mt-2"
                                            >
                                              Others
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-2 col-md-3 col-sm-6 col-12">
                                        <h5 className="dropdown header_underline">
                                          <span>Tax</span>{" "}
                                        </h5>
                                        <div>
                                          <div>
                                            <Link
                                              to="/gstpartner"
                                              className="p-0 mt-3"
                                            >
                                              GST
                                            </Link>
                                          </div>
                                          <div>
                                            <Link
                                              to="/itrpartner"
                                              className="p-0 mt-2"
                                            >
                                              ITR
                                            </Link>
                                          </div>
                                          <div>
                                            <Link
                                              to="/otherstaxpartner"
                                              className="p-0 mt-2"
                                            >
                                              Others
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-2 col-md-3 col-sm-6 col-12">
                                        <h5 className="dropdown header_underline">
                                          <span>Astro</span>{" "}
                                        </h5>
                                        <div>
                                          <div>
                                            <Link
                                              to="/careerpartner"
                                              className="p-0 mt-3"
                                            >
                                              Career
                                            </Link>
                                          </div>
                                          <div>
                                            <Link
                                              to="/relationshippartner"
                                              className="p-0 mt-2"
                                            >
                                              Relationship
                                            </Link>
                                          </div>
                                          <div>
                                            <Link
                                              to="/othersastropartner"
                                              className="p-0 mt-2"
                                            >
                                              Others
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-3 col-md-3 col-sm-6 col-12">
                                        <h5 className="dropdown header_underline">
                                          <span>Heal</span>{" "}
                                        </h5>
                                        <div>
                                          <div>
                                            <Link
                                              to="/careerhealpartner"
                                              className="p-0 mt-3"
                                            >
                                              Career
                                            </Link>
                                          </div>
                                          <div>
                                            <Link
                                              to="/relationshiphealpartner"
                                              className="p-0 mt-2"
                                            >
                                              Relationship
                                            </Link>
                                          </div>
                                          <div>
                                            <Link
                                              to="/othershealpartner"
                                              className="p-0 mt-2"
                                            >
                                              Others
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Tab.Pane>
                                </Tab.Content>
                              </div>
                            </div>
                          </Nav>
                        </Col>
                      </Row>
                    </Tab.Container>

                    {/* <li><a href="/">Drop Down 2</a></li>
                                    <li><a href="/">Drop Down 3</a></li>
                                    <li><a href="/">Drop Down 4</a></li> */}
                  </ul>
                </li>
              )}
              {/* <li><Link className="nav-link scrollto" to="/browsetasks">Browse tasks</Link></li>
                            <li><Link className="nav-link scrollto" to="/howitworks">How it works</Link></li> */}
              {isAuth && (
                <>
                  {localStorage.getItem("user_type") &&
                    localStorage.getItem("user_type") == 1 ? (
                    <li>
                      <Link
                        className="nav-link scrollto"
                        to="/browsetasksbuyer"
                      >
                        Browse Tasks
                      </Link>
                    </li>
                  ) : (
                    <li>
                      <Link className="nav-link scrollto" to="/browsetasks">
                        Browse Tasks
                      </Link>
                    </li>
                  )}
                </>
              )}
              {isAuth && (
                <>
                  {localStorage.getItem("user_type") &&
                    localStorage.getItem("user_type") == 1 ? (
                    <li>
                      <Link className="nav-link scrollto" to="/mytaskbuyer">
                        My Task
                      </Link>
                    </li>
                  ) : (
                    <li>
                      <Link className="nav-link scrollto" to="/mytaskseller">
                        My Task
                      </Link>
                    </li>
                  )}
                </>
              )}
              {isAuth && (
                <>
                  {localStorage.getItem("user_type") &&
                    localStorage.getItem("user_type") == 1 ? (
                    <li>
                      <Link
                        className="nav-link scrollto"
                        to="/chatsuserlistbuyer"
                      >
                        Chats
                      </Link>
                    </li>
                  ) : (
                    <li>
                      <Link
                        className="nav-link scrollto"
                        to="/chatsuserlistseller"
                      >
                        Chats
                      </Link>
                    </li>
                  )}
                </>
              )}
              {!isAuth && (
                <li>
                  {" "}
                  <Link className="nav-link scrollto" to="/contactus">
                    Contact
                  </Link>
                </li>
              )}

              <>
                {localStorage.getItem("user_type") &&
                  localStorage.getItem("user_type") == 1 ? (
                  <li className="become_btn">
                    <Button
                      className="nav-link scrollto"
                      onClick={() => onCompleteSweetAlertSeller()}
                    >
                      Become a Seller
                    </Button>
                  </li>
                ) : (
                  <li className="become_btn">
                    <Button
                      className="nav-link scrollto"
                      onClick={() => onCompleteSweetAlertBuyer()}
                    >
                      Become a Buyer
                    </Button>
                  </li>
                )}
              </>
              {isswalseller && (
                <SweetAlert
                  showCancel
                  cancelBtnText="Cancel"
                  confirmBtnText="Logout"
                  confirmBtnBsStyle="danger"
                  title="You need to signout first to login as seller. Are you sure you want to continue?"
                  onConfirm={() => becomeSeller()}
                  onCancel={() => setIsswalSeller(false)}
                  closeOnClickOutside={false}
                  focusCancelBtn
                ></SweetAlert>
              )}
              {isswalbuyer && (
                <SweetAlert
                  showCancel
                  confirmBtnText="Yes"
                  confirmBtnBsStyle="danger"
                  title="You need to signout first to login as buyer. Are you sure you want to continue?"
                  onConfirm={() => becomeBuyer()}
                  onCancel={() => setIsswalBuyer(false)}
                  closeOnClickOutside={false}
                  focusCancelBtn
                ></SweetAlert>
              )}

              {isAuth ? (
                <React.Fragment>
                  <div className="notification-wrapper">
                    <li className="dropdown">
                      <Link
                        className="nav-link scrollto"
                        to="/"
                        onClick={() =>
                          setShowMobileMenuNotify(!showMobileMenuNotify)
                        }
                      >
                        <span className="notification">
                          <div
                            className="btn-outline-secondary d-flex border-0"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <MdNotifications size="40" color="#ffc107" />
                            {/* {notificationCount > 0 && ( */}
                            {count > 0 && (
                              <span className="rounded-circle rounded-notification">
                                {count}
                              </span>
                            )}
                            {/* )} */}
                          </div>
                        </span>
                      </Link>
                      <ul
                        className={
                          showMobileMenuNotify
                            ? "dropdown-active"
                            : "dropdown-menu dropdown-menu-arrow notifications border-0"
                        }
                      >
                        <p className="noti">Notifications ({count})</p>
                        {notifications?.map((notification, index) => (
                          <li className="notification-item" key={index}>
                            <Button
                              className="p-0"
                              onClick={() => onClickmarkAsRead(notification)}
                            >
                              {/* <div className={notification?.is_read ? 'wrap-notification-content-read' : 'wrap-notification-content-unread'}> */}
                              <div className="wrap-notification-content">

                                <img
                                  src={notification?.user_image?.image}
                                  alt=""
                                  className="img-fluid"
                                />
                                {notification?.is_read == true ? (
                                  <h4 className="notification_read">
                                    {notification?.title}
                                  </h4>
                                ) : (
                                  <h4 className="notification_unread">
                                    {notification?.title}
                                  </h4>
                                )}
                              </div>
                            </Button>
                            <div className="wrap-notification-content-btm">
                              <p>
                                {moment(notification?.created_date).format(
                                  "lll"
                                )}
                              </p>
                            </div>
                          </li>
                        ))}

                        <li className="notification-item-bottom">
                          <div className="wrap-notification-content-notifi">
                            <Link className="" to="/viewnotification">
                              <h5 className="view-notifi">
                                View All Notifications
                              </h5>
                            </Link>
                          </div>
                        </li>
                      </ul>
                    </li>
                  </div>
                  <li className="dropdown">
                    <Link
                      className="nav-link scrollto"
                      to="/"
                      onClick={() =>
                        setShowMobileMenuProfile(!showMobileMenuProfile)
                      }
                    >
                      <React.Fragment>
                        <div
                          className="btn-outline-secondary d-flex border-0"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <img
                            src={
                              localStorage.getItem("user_image")
                                ? localStorage.getItem("user_image")
                                : AvtarImg
                            }
                            alt=""
                            className="img-fluid"
                            style={{
                              width: "44px",
                              height: "44px",
                              borderRadius: "25px",
                              objectFit: "cover"
                            }}
                          />
                        </div>
                        <div className="login-user-name">
                          <h5>
                            <span role="button">
                              {" "}
                              {localStorage.getItem("user_name")
                                ? localStorage.getItem("user_name")
                                : "Login"}
                            </span>
                          </h5>
                        </div>
                      </React.Fragment>
                    </Link>
                    <ul
                      className={
                        showMobileMenuProfile
                          ? "dropdown-active login-user-menu"
                          : "login-user-menu"
                      }
                    >
                      <li className="notification-item">
                        <div className="wrap-notification-content">
                          <MdOutlineManageAccounts
                            size="20"
                            style={{ color: "#000" }}
                          />
                          <Link className="manage-profile" to="/manageprofile">
                            <h4 className="ms-2">Manage My Profile</h4>
                          </Link>
                        </div>
                      </li>
                      <li className="notification-item">
                        <div className="wrap-notification-content">
                          <FiStar size="20" style={{ color: "#000" }} />
                          <Link className="manage-profile" to="/feedback">
                            <h4 className="ms-2">Feedback</h4>
                          </Link>
                        </div>
                      </li>
                      {/* {localStorage.getItem('user_type') && localStorage.getItem('user_type') == 2 &&
                                                <li className="notification-item">
                                                    <div className='wrap-notification-content'>
                                                        <TbFileDescription size="20" style={{ color: "#000" }} />
                                                        <Link className='manage-profile' to='/mytask'>
                                                            <h4 className='ms-2'>My Task</h4>
                                                        </Link>
                                                    </div>
                                                </li>
                                            } */}
                      <li className="notification-item">
                        <div className="wrap-notification-content">
                          <BiRupee size="20" style={{ color: "#000" }} />
                          <Link
                            className="manage-profile"
                            to={
                              localStorage.getItem("user_type") == 2
                                ? "/paymenthistoryseller"
                                : "/paymenthistorybuyer"
                            }
                          >
                            <h4 className="ms-2">Payment History</h4>
                          </Link>
                        </div>
                      </li>
                      <li className="notification-item">
                        <div className="wrap-notification-content">
                          <RiBankLine size="20" style={{ color: "#000" }} />
                          <Link
                            className="manage-profile"
                            to="/bankdetails"
                          >
                            <h4 className="ms-2">
                              Add Bank Account Details
                            </h4>
                          </Link>
                        </div>
                      </li>
                      {localStorage.getItem("user_type") &&
                        localStorage.getItem("user_type") == 1 && (
                          <li className="notification-item">
                            <div className="wrap-notification-content">
                              <RiHandCoinLine
                                size="20"
                                style={{ color: "#000" }}
                              />
                              <Link className="manage-profile" to="/addressdetails">
                                <h4 className="ms-2">Add Address Details</h4>
                              </Link>
                            </div>
                          </li>
                        )}
                      {localStorage.getItem("user_type") &&
                        localStorage.getItem("user_type") == 2 && (
                          <li className="notification-item">
                            <div className="wrap-notification-content">
                              <RiHandCoinLine
                                size="20"
                                style={{ color: "#000" }}
                              />
                              <Link className="manage-profile" to="/gstdetails">
                                <h4 className="ms-2">Add GST Details</h4>
                              </Link>
                            </div>
                          </li>
                        )}
                      <li className="notification-item">
                        <div className="wrap-notification-content">
                          <BiWallet size="20" style={{ color: "#000" }} />
                          <Button
                            className="manage-profile p-0"
                            onClick={handleShow}
                          >
                            <h4 className="ms-2 mt-2">My Wallet</h4>
                          </Button>
                        </div>
                      </li>
                      {isswaldelete && (
                        <SweetAlert
                          showCancel
                          reverseButtons={true}
                          confirmBtnText="Yes"
                          confirmBtnBsStyle="danger"
                          title="Are you sure you want to delete this account?"
                          onConfirm={() => deleteAccount()}
                          onCancel={() => setIsswalDelete(false)}
                          closeOnClickOutside={false}
                          focusCancelBtn
                        ></SweetAlert>
                      )}
                      <li className="notification-item">
                        <div className="wrap-notification-content">
                          <AiOutlineDelete size="20" style={{ color: "#000" }} />
                          <span role="button" className="">
                            <div className="manage-profile">
                              <h4
                                className="ms-2 mt-2"
                                onClick={() => onDeleteSweetAlertSeller()}
                              >
                                Delete Account
                              </h4>
                            </div>
                          </span>
                        </div>
                      </li>
                      <li className="notification-item">
                        <div className="wrap-notification-content">
                          <RiHandCoinLine
                            size="20"
                            style={{ color: "#000" }}
                          />
                          <Link className="manage-profile" to="/complaint">
                            <h4 className="ms-2">Complaint Form</h4>
                          </Link>
                        </div>
                      </li>
                      <li className="notification-item">
                        <div className="wrap-notification-content">
                          <VscSignOut size="20" style={{ color: "#000" }} />
                          <span role="button" className="">
                            <div className="manage-profile">
                              <h4
                                className="ms-2 mt-2"
                                onClick={() => onClickLogout()}
                              >
                                Log Out
                              </h4>
                            </div>
                          </span>
                        </div>
                      </li>
                    </ul>
                  </li>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <li>
                    <Link className="nav-link scrollto" to="/signup">
                      Sign Up
                    </Link>
                  </li>
                  <li>
                    <Link className="getstarted scrollto" to="/signin">
                      Sign In
                    </Link>
                  </li>
                </React.Fragment>
              )}
              <Modal
                className="wallet-balance-modal"
                show={show}
                onHide={handleClose}
                backdrop="static"
              >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  <div>
                    <h5> Wallet Balance</h5>
                  </div>
                  <Card className="wallet-balance mt-3">
                    <Card.Body>
                      <div className="wallet-balance-icon">
                        <div className="wallet-balance-amount">
                          <BiRupee size="40" style={{ color: "#000" }} />
                          <h6>
                            {parseFloat(
                              wallet?.wallet_balance
                                ? wallet?.wallet_balance
                                : 0
                            ).toFixed(2)}
                          </h6>
                        </div>
                        <IoWallet size="50" style={{ color: "#1cbbee" }} />
                      </div>
                      <div className="mt-5">
                        {localStorage.getItem("user_type") &&
                          localStorage.getItem("user_type") == 1 && (
                            <div className="switches-container mb-4">
                              <input
                                id="addWallet"
                                onClick={() => {
                                  handleWalletTab("add");
                                }}
                                type="radio"
                                name="type_of_user"
                                value="1"
                                checked={walletTab == "add" ? true : false}
                                onChange={() => { }}
                              />
                              <input
                                id="withdrawWallet"
                                type="radio"
                                name="type_of_user"
                                onClick={() => {
                                  handleWalletTab("withdraw");
                                }}
                                value="2"
                                checked={walletTab == "withdraw" ? true : false}
                                onChange={() => { }}
                              />
                              <label htmlFor="addWallet">Add</label>
                              <label htmlFor="withdrawWallet">Withdraw</label>
                              <div className="switch-wrapper">
                                <div className="switch">
                                  <div>Add</div>
                                  <div>Withdraw</div>
                                </div>
                              </div>
                            </div>
                          )}
                        {/* <div className="withdraw-money">
                          {walletTab == "add" ? (
                            <h5>Add Money</h5>
                          ) : (
                            <h5>Request htmlFor withdrawal</h5>
                          )}
                          <Form>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <div className="withdraw">
                                <BiRupee
                                  size="20"
                                  style={{ color: "#000" }}
                                  className="withdraw-icon"
                                />
                                <Form.Control
                                  type="number"
                                  value={amount}
                                  onKeyDown={(event) => {
                                    if (event.key === '-' || event.key === 'e' || event.key === '+') {
                                      event.preventDefault();
                                    }
                                  }}
                                  onChange={(e) => {
                                    const input = e.target.value;
                                    const regex = /^[0-9\b]+$/;

                                    if (input === '' || regex.test(input)) {
                                      setamount(e.target.value)
                                    }
                                  }}
                                  // onChange={(e) => setamount(e.target.value)}
                                  placeholder="0"
                                />
                              </div>
                            </Form.Group>
                            <div className="withdraw-btn mt-5">
                              {walletTab == "add" ? (
                                <>
                                  {isloader == true ? (
                                    <div className="loader">
                                      <img
                                        src={loader}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                  ) : (
                                    <button
                                      className="btn btn-primary"
                                      onClick={handleSubmit}
                                    >
                                      Add
                                    </button>
                                  )}
                                </>
                              ) : (
                                <>
                                  {isloader == true ? (
                                    <div className="loader">
                                      <img
                                        src={loader}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                  ) : (
                                    <button
                                      className="btn btn-primary"
                                      onClick={(e) => withdrawAmount(e)}
                                    >
                                      Send Request
                                    </button>
                                  )}
                                </>
                              )}
                            </div>
                          </Form>
                        </div> */}
                        <div className="withdraw-money">
                          {walletTab === "add" ? (
                            <>
                              <h5>Add Money</h5>
                              <Form>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                  <div className="withdraw">
                                    <BiRupee
                                      size="20"
                                      style={{ color: "#000" }}
                                      className="withdraw-icon"
                                    />
                                    <Form.Control
                                      type="number"
                                      value={amount}
                                      onKeyDown={(event) => {
                                        if (
                                          event.key === "-" ||
                                          event.key === "e" ||
                                          event.key === "+"
                                        ) {
                                          event.preventDefault();
                                        }
                                      }}
                                      onChange={(e) => {
                                        const input = e.target.value;
                                        const regex = /^[0-9\b]+$/;

                                        if (input === "" || regex.test(input)) {
                                          setamount(e.target.value);
                                        }
                                      }}
                                      placeholder="0"
                                    />
                                  </div>
                                </Form.Group>

                                <div className="withdraw-btn mt-5">
                                  {isloader === true ? (
                                    <div className="loader">
                                      <img src={loader} alt="" className="img-fluid" />
                                    </div>
                                  ) : (
                                    <button className="btn btn-primary" onClick={handleSubmit}>
                                      Add
                                    </button>
                                  )}
                                </div>
                              </Form>
                            </>
                          ) : (
                            <>
                              {upiIdSaved || upiId !== "" ? (
                                <>
                                  <h5>Request For withdrawal</h5>
                                  {editingUpiId ? (
                                    <>
                                      <Form.Group className="mb-3" controlId="formBasicUPI">
                                        <div className="withdraw">
                                          <img src={upi_icon} alt="UPI ICON" className="upi-icon" />
                                          <Form.Control
                                            type="text"
                                            value={upi}
                                            onChange={(e) => setupi(e.target.value)}
                                            placeholder="Enter UPI ID"
                                            className="upi-id-input"
                                          />
                                        </div>
                                        <div className="withdraw-btn mt-2">
                                          {!upiIdSaved && (
                                            <button className="btn btn-primary" onClick={saveUPI}>
                                              Save
                                            </button>
                                          )}
                                        </div>
                                      </Form.Group>
                                    </>
                                  ) : (
                                    <>
                                      <div className="saved_upi withdraw">
                                        <img src={upi_icon} alt="UPI ICON" className="upi-icon" />
                                        <Form.Control
                                          className="upi-id-input"
                                          value={upiId}
                                          onChange={(e) => setupiId(e.target.value)}
                                        />
                                        <AiFillEdit onClick={() => { setEditingUpiId(true); setUpiIdSaved(false); }} /> {/* Display edit button */}
                                      </div>
                                    </>
                                  )}
                                  <Form>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                      <div className="withdraw">
                                        <BiRupee size="20" style={{ color: "#000" }} className="withdraw-icon" />
                                        <Form.Control
                                          type="number"
                                          value={amount}
                                          onKeyDown={(event) => {
                                            if (event.key === "-" || event.key === "e" || event.key === "+") {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(e) => {
                                            const input = e.target.value;
                                            const regex = /^[0-9\b]+$/;

                                            if (input === "" || regex.test(input)) {
                                              setamount(e.target.value);
                                            }
                                          }}
                                          placeholder="0"
                                        />
                                      </div>
                                    </Form.Group>

                                    <div className="withdraw-btn mt-5">
                                      {isloader === true ? (
                                        <div className="loader">
                                          <img src={loader} alt="" className="img-fluid" />
                                        </div>
                                      ) : (
                                        <button className="btn btn-primary" onClick={withdrawAmount}>
                                          Send Request
                                        </button>
                                      )}
                                    </div>
                                  </Form>
                                </>
                              ) : (
                                <>
                                  <h5>Enter UPI ID</h5>
                                  <Form.Group className="mb-3" controlId="formBasicUPI">
                                    <div className="withdraw">
                                      <img src={upi_icon} alt="UPI ICON" className="upi-icon" />
                                      <Form.Control
                                        className="upi-id-input"
                                        type="text"
                                        value={upi}
                                        onChange={(e) => setupi(e.target.value)}
                                        placeholder="Enter UPI ID"
                                      />
                                    </div>
                                    <div className="withdraw-btn mt-5">
                                      {!upiIdSaved && (
                                        <button className="btn btn-primary" onClick={saveUPI}>
                                          Save
                                        </button>
                                      )}
                                    </div>
                                  </Form.Group>
                                </>
                              )}
                            </>

                          )}
                        </div>

                      </div>
                    </Card.Body>
                  </Card>

                  {/* 
                                                            <Card className='withdraw-money mt-5'>
                                                                <Card.Body>

                                                                </Card.Body>
                                                            </Card> */}
                </Modal.Body>
              </Modal>
            </ul>
            <i
              className={
                showMediaIcons
                  ? "bi mobile-nav-toggle bi-x"
                  : "bi bi-list mobile-nav-toggle"
              }
              onClick={() => setShowMediaIcons(!showMediaIcons)}
            ></i>
          </nav>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
